import { PermissionAction, PermissionSubject } from '@/enums';
import { useEmployeePermissionsLoader } from '@/domain/access-control/blocs/loaders/use-employee-permissions-loader';
import { useSalesRepConfig } from '@/experiences/sales-portal/blocs/hooks/use-sales-rep-config';

/**
 * Whether estimated commission may be displayed for the current rep.
 *
 * @param supplierUUID - The supplier uuid
 * @param authenticatedUserUUID - The authenticated user's uuid
 * @param chatUUID - Optional chat uuid for chat-specific config
 * @returns True when commission metrics may be rendered
 */
export const useIsCommissionsEnabled = (
  supplierUUID: string,
  authenticatedUserUUID: string | null,
  chatUUID?: string | null,
): boolean => {
  const { can } = useEmployeePermissionsLoader(
    supplierUUID,
    authenticatedUserUUID,
  );
  const { loading, salesRepConfig } = useSalesRepConfig(supplierUUID, chatUUID);

  return (
    !loading &&
    can(PermissionAction.Read, PermissionSubject.Commissions) &&
    (salesRepConfig?.commission_settings?.draft_order_commission_enabled ??
      false)
  );
};
